module.exports = __webpack_public_path__ + "img/img_judges5.a1e0ca63.png";